(function () {
  function unwrapContentNodes(source) {
    let nodes = Array.from(source.children);

    while (nodes.length === 1 && nodes[0].tagName === 'DIV') {
      nodes = Array.from(nodes[0].children);
    }

    return nodes;
  }

  function stripInlineStyles(node) {
    if (!node || node.nodeType !== 1) return;

    node.removeAttribute('style');

    Array.from(node.children).forEach(stripInlineStyles);
  }

  function buildFaqAccordion(source) {
    const children = unwrapContentNodes(source);
    const categories = [];
    let currentCategory = null;
    let currentItem = null;

    for (const node of children) {
      const tag = node.tagName;

      if (tag === 'H2') {
        currentCategory = { title: node.textContent.trim(), items: [] };
        categories.push(currentCategory);
        currentItem = null;
      } else if (tag === 'H3') {
        if (!currentCategory) {
          currentCategory = { title: 'General', items: [] };
          categories.push(currentCategory);
        }
        currentItem = { question: node.textContent.trim(), answerNodes: [] };
        currentCategory.items.push(currentItem);
      } else if (currentItem) {
        const answerNode = node.cloneNode(true);
        stripInlineStyles(answerNode);
        currentItem.answerNodes.push(answerNode);
      }
    }

    if (!categories.length) return null;

    const wrapper = document.createElement('div');
    wrapper.className = 'texan-faq__categories';

    categories.forEach(function (category, categoryIndex) {
      const section = document.createElement('section');
      section.className = 'texan-faq__category';

      const heading = document.createElement('h2');
      heading.className = 'texan-faq__category-title';
      heading.textContent = category.title;
      section.appendChild(heading);

      const itemsWrap = document.createElement('div');
      itemsWrap.className = 'texan-faq__items';

      category.items.forEach(function (item, itemIndex) {
        const details = document.createElement('details');
        details.className = 'texan-faq__item';
        if (categoryIndex === 0 && itemIndex === 0) {
          details.open = true;
        }

        const summary = document.createElement('summary');
        summary.className = 'texan-faq__question';

        const questionText = document.createElement('span');
        questionText.className = 'texan-faq__question-text';
        questionText.textContent = item.question;
        summary.appendChild(questionText);

        const icon = document.createElement('span');
        icon.className = 'texan-faq__icon';
        icon.setAttribute('aria-hidden', 'true');
        summary.appendChild(icon);

        const answer = document.createElement('div');
        answer.className = 'texan-faq__answer rte';
        item.answerNodes.forEach(function (answerNode) {
          answer.appendChild(answerNode);
        });

        details.appendChild(summary);
        details.appendChild(answer);
        itemsWrap.appendChild(details);
      });

      section.appendChild(itemsWrap);
      wrapper.appendChild(section);
    });

    return wrapper;
  }

  function initFaq() {
    const root = document.querySelector('[data-texan-faq]');
    if (!root) return;

    const source = root.querySelector('.texan-faq__source');
    if (!source || source.dataset.enhanced === 'true') return;

    const accordion = buildFaqAccordion(source);
    if (!accordion) return;

    source.replaceChildren(accordion);
    source.classList.add('texan-faq__source--enhanced');
    source.dataset.enhanced = 'true';
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initFaq);
  } else {
    initFaq();
  }
})();
